<template>
	<div>
		<modalconfirm ref="modalApprovalRetur" @action="proccessRetur"/>
		<div class="text-h5">Approval Retur</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-autocomplete item-value="por_code" @change="getDetail(por_code)" hide-details="auto" v-model="por_code" :items="OptionRetur" label="Kode Retur" outlined dense no-data-text="Belum ada data tersedia">
								<template v-slot:item = {item}>
									{{item.por_code}} - {{item.supplier_name}}
								</template>
								<template v-slot:selection = {item}>
									{{item.por_code}}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" class="pb-5" v-if="Object.keys(detailRetur).length > 0">
							<div class="font-weight-bold">Detail Supplier</div>
							<v-row>
								<v-col cols="12" md="4">
									<div class="d-flex">
										<v-icon>mdi-warehouse</v-icon>
										<div class="pl-3">{{ detailRetur.supplier_name }}</div>
									</div>
									<div class="d-flex pt-2">
										<v-icon>mdi-email</v-icon>
										<div class="pl-3">{{ detailRetur.supplier_email }}</div>
									</div>
								</v-col>
								<v-col cols="12" md="8">
									<div class="d-flex">
										<v-icon>mdi-phone</v-icon>
										<div class="pl-3">{{ detailRetur.supplier_mobilephone }}</div>
									</div>
									<div class="d-flex pt-2">
										<v-icon class="icon-align-top">mdi-map-marker</v-icon>
										<div class="pl-3">{{ addresText }}</div>
									</div>
								</v-col>
							</v-row>
							<div class="font-weight-bold">Catatan : {{ detailRetur.por_note ? detailRetur.por_note : '-' }}</div>
						</v-col>
						<v-col cols="12">
							<v-alert v-if="responseError.product" type="error" elevation="1">
								{{responseError.product}}
							</v-alert>
							<v-simple-table class="white-row">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="20%" class="text-left">Kode Produk</th>
											<th width="20%" class="text-left">Jumlah Permintaan</th>
											<th width="15%" class="text-left">Jumlah Approval</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="product in productRetur" :key="product.por_detail_product_id">
											<td> {{ product.por_detail_product_name }} </td>
											<td> {{ product.por_detail_product_code }} </td>
											<td> {{ product.por_detail_quantity_requested | toNumber }} {{ product.por_detail_product_unit }}</td>
											<td>
												<v-currency-field v-model.lazy="product.quantity" label="Jumlah" :rules="[inputrules.required, inputrules.notnull]" :outlined="true" dense hide-details="auto" background-color="white" class="py-3 details-mb-0"/>
											</td>
										</tr>
									</tbody>
									<tfoot>
									</tfoot>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4 pt-5">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" :disabled="!por_code" outlined class="text-capitalize" @click="reject">Tolak</v-btn>
				<v-btn color="primary darken-1" :disabled="!por_code" depressed class="text-capitalize" @click="approve">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			duit: 2222,
			por_code: '',
			poProccess: '',
			headers: [
			{ text: 'Aksi', align: 'start', value: 'action', sortable: false},
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Jumlah Permintaan', value: 'por_detail_quantity_requested', align: 'center'},
			{ text: 'Jumlah Disetujui', value: 'quantity', width: '17%'},
			],
			productRetur: [],
		}
	},
	props: {
	},
	computed: {
		...mapState('retur', ['detailRetur', 'response', 'responseError', 'OptionRetur', 'alertMultiple']),

		addresText(){
			var data = []
			if (this.detailRetur) {
				if (this.detailRetur.supplier_address)
					data.push(this.detailRetur.supplier_address)
				if (this.detailRetur.supplier_subdistrict_name)
					data.push(this.detailRetur.supplier_subdistrict_name)
				if (this.detailRetur.supplier_city_name)
					data.push(this.detailRetur.supplier_city_name)
				if (this.detailRetur.supplier_province_name)
					data.push(this.detailRetur.supplier_province_name)
			}
			return data.join(', ')
		}
	},
	methods: {
		...mapActions('retur', ['getDetailRetur', 'approveRetur', 'rejectRetur', 'getOptionReturforApprove']),
		...mapMutations('retur', ['setDetailRetur', 'clearDataRetur', 'multipleAlert', 'saveResponse']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailRetur(code).then( () => {
					this.productRetur = this.detailRetur.por_detail.map((el, index) => {
						el.index = index
						el.quantity = el.por_detail_quantity_requested
						return el
					})
				})
			} else {
				this.setDetailRetur({})
				this.productRetur = []
			}
		},
		approve(){
			this.poProccess = 'approve'
			let msg = "Yakin akan memproses Retur ini?"
			this.$refs.modalApprovalRetur.setMessage(msg)
			this.$refs.modalApprovalRetur.showConfirm()
		},
		reject(){
			this.poProccess = 'reject'
			let msg = "Yakin akan membatalkan Retur ini?"
			this.$refs.modalApprovalRetur.setMessage(msg)
			this.$refs.modalApprovalRetur.showConfirm()
		},
		async proccessRetur() {
			await this.setOverlay(true)
			await this.$refs.modalApprovalRetur.hideConfirm()
			var product = await this.productRetur.map( el => {
				return {
					product_id : el.por_detail_product_id,
					product_name : el.por_detail_product_name,
					quantity : el.quantity,
				}
			})
			let msg = await []
			await this.multipleAlert(msg)
			if (msg.length == 0) {
				if (this.poProccess == 'approve') {
					await this.approveRetur({
						supplier_id: this.detailRetur.por_supplier_id,
						por_id : this.detailRetur.por_id,
						product : product
					}).then(() => {
						if (this.response.code == 200.) {
							this.resetForm()
						}
					})
				} else if (this.poProccess == 'reject') {
					await this.rejectRetur({
						por_id : this.detailRetur.por_id,
					}).then(() => {
						if (this.response.code == 200.) {
							this.resetForm()
						}
					})
				}
			}
			await this.setOverlay(false)
		},
		resetForm() {
			this.saveResponse({})
			this.productRetur = []
			this.getOptionReturforApprove()
			this.por_code = ''
			this.setDetailRetur({})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Approval Retur`)
		this.getOptionReturforApprove().then(() => {
			if (this.$route.params.code) {
				this.por_code = this.$route.params.code
				this.getDetail(this.$route.params.code)
			}
		})
	},
	beforeDestroy() {
		this.clearDataRetur()
	},
	watch: {
	}
}
</script>